module.exports = __webpack_public_path__ + "static/1333170592.bd2b5367.jpg";